export enum LoanPaymentScheduleType {
  Automated = 0,
  Custom = 1,
  Migrated = 2,
  Custom2 = 3,
}
